export default {
	search(query, cb, ecb) {
		this.http
			.get('/material/search', {
				params: query
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/material/update', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove(id, cb) {
		this.http.get('/material/remove/' + id, {}).then((r) => {
			if (cb) cb(r)
		})
	},
	getSKUAtts(id, cb) {
		this.http.get('/material/skuAtts2/' + id, {}).then((response) => {
			cb(response)
		})
	},
	getStock(id, sku, cb) {
		this.http
			.get('/material/stockOf/' + id + '/' + JSON.stringify(sku), {})
			.then((response) => {
				cb(response)
			})
	},
	getStocks(shopid, cb) {
		this.http.get(`/material/getStocks/${shopid}`, {}).then((res) => {
			cb(res)
		})
	},
	searchStock(params, cb) {
		this.http.get(`/material/searchStock`, { params }).then((res) => {
			cb(res)
		})
	},
	takingStock(shopid, mid, to, cb) {
		this.http
			.get(`/material/takingStock/${shopid}/${mid}/${to}`)
			.then((r) => cb(r))
	},
	searchStockLog(params, cb) {
		this.http.get(`/material/searchStockLog`, { params }).then((r) => cb(r))
	},
	getByCategory(cats, cb) {
		this.http
			.get('/material/getByCategories/' + cats.join(','), {})
			.then((response) => {
				cb(response)
			})
	},
	getAll(catid, params, cb) {
		this.http
			.post('/material/getByCategory/' + catid, params)
			.then((response) => {
				cb(response)
			})
	},
	getAllByTag(tag, params, cb) {
		this.http.post('/material/getByTag/' + tag, params).then((response) => {
			cb(response)
		})
	},
	getById(id, cb) {
		this.http.get(`/material/getById/${id}`, {}).then((response) => {
			cb(response)
		})
	},
	getSKUs(mid, cb) {
		this.http.get(`/material/getSKUs/${mid}`, {}).then((response) => {
			cb(response)
		})
	},
	getSKUsById(ids, cb) {
		this.http.get('/material/getSKUsById/' + ids, {}).then((response) => {
			cb(response)
		})
	},
	updateSKU(id, att, to, cb) {
		this.http
			.post(`/material/updateSKU/${id}/${att}/${to}`)
			.then((r) => cb(r))
	},
	updateStock(id, to, cb) {
		this.http.post(`/material/updateStock/${id}/${to}`).then((r) => cb(r))
	},
	searchBatch(query, cb, ecb, prof = '') {
		this.http
			.get(`/material/searchBatch/${prof}`, {
				params: query
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getBatchById(id, cb) {
		this.http.get(`/material/getBatchById/${id}`, {}).then((response) => {
			cb(response)
		})
	},
	updateBatch(form, cb, ecb) {
		this.http
			.post('/material/updateBatch', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	removeBatch(id, cb, ecb) {
		this.http
			.post(`/material/removeBatch/${id}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchBatchItem(params, cb, ecb, prof = '') {
		this.http
			.get(`/material/searchBatchItem/${prof}`, {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateBatchItem(form, cb, ecb) {
		this.http
			.post('/material/updateBatchItem', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	removeBatchItem(id, cb, ecb) {
		this.http
			.post(`/material/removeBatchItem/${id}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchSupplier(query, cb, ecb) {
		this.http
			.get('/material/searchSupplier', {
				params: query
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getStockByShop(shopid, params, cb, ecb) {
		this.http
			.get(`/material/getStockByShop/${shopid}`, {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateStock(form, cb, ecb) {
		this.http
			.get('/material/updateStock', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
